<capra-button
  capraTooltip
  [tooltipContent]="tooltipContent"
  [tooltipContentIsHtml]="true"
  [tooltipPlacement]="tooltipPlacement"
  [text]="isSyncing ? 'Syncing...' : 'Sync'"
  [disabled]="isSheetsEnabled === false || isSyncing"
  size="small"
  variant="secondary"
  color="neutral"
  data-test="sync-dataset-button"
  (clicked)="onSyncClicked()"
></capra-button>
